import { memo, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./congratulationsPage.module.scss";
import { images } from "../../constants/images";
import IcarReportModal from "../Sell/IcarReportModal";
import { Modal } from "@mui/material";
import ButtonShared from "../../components/Button";
import ModalPayment from "../LinzeCheck/EntryPoint/components/ModalPayment";

interface CongratulationsPageProps {
    title?: string;
    text?: string;
    buttonText?: string;
    onButtonClick?: () => void;
}

const CongratulationsPage = ({ title: propTitle, text: propText, buttonText: propButtonText, onButtonClick }: CongratulationsPageProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [basePath, setBasePath] = useState<string>('');
    const title = location.state?.title || propTitle || "Ya eres parte de Linze.";
    const text = location.state?.text || propText || "Encuentra tu próximo auto o publica el tuyo con solo un par de clics. ¡Un nuevo camino te espera!";
    const buttonText = location.state?.buttonText || propButtonText || "Explora aquí";

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        } else {
            const currentPath = location.pathname;
            const basePath = currentPath.includes('/agradecimiento')
                ? currentPath.split('/agradecimiento')[0]
                : '/';

            setBasePath(basePath);
            switch (basePath) {
                case '/registro':
                    navigate('/buscar/autos/usados');
                    break;
                case '/comprar/agendar-inspeccion':
                    navigate('/perfil/mis_compras');
                    break;
                case '/comprar/agendar-inspeccion/credito':
                    navigate('/perfil/mis_compras');
                    break;
                case '/vender-auto/detalle':
                    navigate('/perfil/mis_publicaciones');
                    break;
                case '/financiar-auto':
                    navigate('/buscar/autos/usados');
                    break;
                default:
                    navigate(basePath || '/');
                    break;
            }
        }
    };

    useEffect(() => {
        const currentPath = location.pathname;
        const path = currentPath.includes('/agradecimiento')
            ? currentPath.split('/agradecimiento')[0]
            : '/';
        setBasePath(path);
    }, [location.pathname]);

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <img src={images.thankYouLinze} alt="Linze" title="Linze" className={styles.image} />
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.text}>{text}</p>
                <button className={styles.button} onClick={handleButtonClick}>{buttonText}</button>
            </div>
        </div>

    );
};

export default CongratulationsPage;